/**
 * Did this event start on a control the row does not own?
 *
 * A row's per-cell links and buttons `stopPropagation` on click but NOT on `auxclick`,
 * so without this a middle-click on a submission badge opens two tabs.
 */
export function isNestedInteractive(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return target.closest("a, button, input, select, textarea, [role='button']") !== null;
}
